import { render, staticRenderFns } from "./Protectors.vue?vue&type=template&id=65c03429"
import script from "./Protectors.vue?vue&type=script&lang=js"
export * from "./Protectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports